<template>
  <!-- <div class="row justify-left"> -->
    <q-toggle
      v-if="modelType === 2 && theModel?.Positive !== undefined && !isParameter"
      v-model="theModel.Positive"
      class="q-mr-none q-pr-none"
      checked-icon="add"
      :style="shiftTop ? 'margin-top: -2;' : 'margin-top: 0;'"
      :class="`q-pa-none toggle-checkbox q-mr-none ${modelType === 2 ?'unset-items-center' : 'items-center'}`"
      color="navy"
      label=" "
      size="xs"
      unchecked-icon="remove"
    />
      <!-- <q-input outlined dense :style="'min-width: 95px; max-width: 100px;'+(shiftTop ? 'margin-top: -2px;' : '')"
        class="thin-input-date q-my-auto" :color="sdateInnerValid ? 'grey-7' : 'red'"
        v-model="sdateModel" mask="##.##.#### ##:##" hide-bottom-space> -->
      <!-- <DateTimeSelector v-model="(theModel as SelectionDateStampsFilterSend).StartDate" /> -->
      <div :style="(shiftTop ? 'margin-top: -2px;' : 'margin-top: 2px;')">
        <VueDatePicker utc="preserve" timezone="Europe/Moscow" :locale="$i18n.locale" :style="'width: '+fieldWidth+'px; min-width: '+fieldWidth+'px; max-width: '+fieldWidth+'px;'" :teleport="true"
        v-model="(this.theModel as SelectionDateStampsFilterSend).StartDate" :enable-time-picker="showTime"
        :clearable="false" :required="true" :format="showTime ? formatTime : formatDate" :text-input="textInputOptions" />
      </div>
      
      <!-- <input dense :style="'min-width: 100px; max-width: 200px;'+(shiftTop ? 'margin-top: -2px;' : '')"
          class="thin-input q-my-auto" debounce="500" type="datetime-local" color="green"
          v-model="sdateInnerModel" hide-bottom-space  /> -->
      <div :class="['cursor-pointer', 'text-grey-8' ]" :style="(shiftTop ? 'margin-top: -4px;' : 'margin-top: 3px;')">
        &nbsp;-&nbsp;
      </div>
      <div :style="(shiftTop ? 'margin-top: -2px;' : 'margin-top: 2px;')">
        <VueDatePicker utc="preserve" timezone="Europe/Moscow" :locale="$i18n.locale" :style="'width: '+fieldWidth+'px; min-width: '+fieldWidth+'px; max-width: '+fieldWidth+'px;'" 
        v-model="(this.theModel as SelectionDateStampsFilterSend).EndDate" :teleport="true" 
        :clearable="false" :disabled="theModel && (theModel as SelectionDateStampsFilterSend).EndDateIsToday"
        :format="showTime ? formatTime : formatDate" :text-input="textInputOptions" :enable-time-picker="showTime" />
      </div>

      <!-- <q-input outlined dense :style="'min-width: 95px; max-width: 100px;'+(shiftTop ? 'margin-top: -2px;' : '')"
        class="thin-input-date q-my-auto" :color="edateInnerValid ? 'grey-7' : 'red'"
        v-model="edateModel" mask="##.##.####" fill-mask="_" hide-bottom-space
        :disable="theModel && (theModel as SelectionDateStampsFilterSend).EndDateIsToday"
      >
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer" size="xs">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-date minimal v-model="(theModel as SelectionDateStampsFilterSend).EndDate" 
              mask="YYYY-MM-DDTHH:mm">
                <div class="row items-center justify-end">
                  <q-btn v-close-popup :label="$t('close_label')" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input> -->
    <!-- </div> -->
    <mosta-checkbox class="q-my-none q-py-none text-grey-8"
    @update:model-value="updateCheck" :style="'margin-left: 6px; margin-top: 4px;'"
      v-model="(theModel as SelectionDateStampsFilterSend).EndDateIsToday" :label="$t('today_calendar')" />
    
    <q-btn
      class="q-px-none q-mx-none unset-items-center"
      style="margin-left: 2px;"
      flat
      dense
      v-if="modelType === 2 && theModel?.Positive !== undefined && !isParameter"
      :aria-label="$t('delete_filter')"
      icon="close"
      size="sm"
      tabindex="-1"
      color="grey-8"
      @click="emitDelete"
    >
      <q-tooltip :delay="300" anchor="top middle" self="center middle">
        {{ $t('remove') }}
      </q-tooltip>
    </q-btn>
  <!-- </div> -->
</template>
  
<script lang="ts">
  import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
  import { SelectionDateStampsFilterSend } from '@/models/interfaces/entity-settings/filters/filters';
  import { SelectionFilterGroupSendDescriptor } from '@/models/etc/types';
  import DateTimeSelector from '@/components/common/datetime-selector/DateTimeSelector.vue';
  import { date } from 'quasar';
  import MostaCheckbox from '@/components/common/basic/MostaCheckbox.vue';

  @Component({
    name: 'DateRangeDisplayItem',
    components: { DateTimeSelector, MostaCheckbox }
  })
  export default class DateRangeDisplayItem extends Vue {
    @Prop({ default: SelectionFilterGroupSendDescriptor.Datestamps })
    modelType!: SelectionFilterGroupSendDescriptor
    @Prop({ default: {} as SelectionDateStampsFilterSend })
    modelValue: SelectionDateStampsFilterSend | undefined | null
    
    @Emit("update:modelValue") emitModelValue(arg: SelectionDateStampsFilterSend | undefined | null) { return arg; }
    @Emit("onDeleteClick") emitDelete(arg: any) { return arg; }

    @Prop({ default: false })
    isParameter!: boolean
    @Prop({ default: false })
    shiftTop!: boolean

    @Prop({ default: false })
    showTime!: boolean

    sdateInnerValid: boolean = true
    edateInnerValid: boolean = true

    sdateInnerModel: any

    get textInputOptions() {
      return {
        enterSubmit: true,
        tabSubmit: true,
        openMenu: 'toggle',
        rangeSeparator: '-',
        selectOnFocus: false,
        format: this.showTime ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'
      }
    }

    formatDate (date: Date): string {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${year}`;
    }

    formatTime (date: Date): string {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const hour = date.getHours();
      const minute = date.getMinutes();

      return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${year} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
    }

    get fieldWidth() {
      return this.showTime ? 140 : 100;
    }

    get sdateModel() {
      if (this.theModel && (this.theModel as SelectionDateStampsFilterSend).StartDate) {
        return new Date(""+(this.theModel as SelectionDateStampsFilterSend).StartDate)
      }
      return null
    }

    set sdateModel(arg: any) {
      if (arg) {
        
        const datem = date.extractDate(arg, "YYYY-MM-DDTHH:mm");
        (this.theModel as SelectionDateStampsFilterSend).StartDate = new Date(datem)
      } else {
        this.sdateInnerValid = false;
        // (this.theModel as SelectionDateStampsFilterSend).StartDate = undefined
      }
    }

    get edateModel() {
      if (this.theModel && (this.theModel as SelectionDateStampsFilterSend).EndDate) {
        return date.formatDate(new Date(""+(this.theModel as SelectionDateStampsFilterSend).EndDate), 'YYYY-MM-DDTHH:mm')
      }
      return undefined
    }

    set edateModel(arg: any) {
      if (arg) {
        const datem = date.extractDate(arg, "YYYY-MM-DDTHH:mm");
        (this.theModel as SelectionDateStampsFilterSend).EndDate = new Date(datem)
      } else {
        this.sdateInnerValid = false;
        (this.theModel as SelectionDateStampsFilterSend).EndDate = undefined
      }
    }

    get theModel(): SelectionDateStampsFilterSend | undefined | null {
      return this.modelValue
    }

    set theModel(val: SelectionDateStampsFilterSend | undefined | null) {
      this.emitModelValue(val)
    }

    updateCheck(val: any) {
      if (!this.theModel) { return }
      if (val) {
        this.theModel.EndDate = undefined
      } else {
        this.theModel.EndDate = new Date()
      }
    }
  }
</script>
  
<style lang="scss">
// .vdp-datepicker__calendar {
//   position: fixed !important;
//   top: auto;
// }
</style>